var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaabajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 39,
    viewBox: "0 0 19 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10104 1.90833C9.10104 10.23 9.10104 18.5518 9.10104 26.8735C9.10104 29.3607 9.29334 31.6291 9.61991 34.0784C9.67923 34.5233 10.089 35.8873 9.33824 35.2199C8.12624 34.1426 6.90232 33.2629 5.63201 32.2697C4.55953 31.4313 0.78113 29.796 1.98508 30.4314C4.32134 31.6645 6.61141 33.5899 8.68594 35.2495C9.13847 35.6116 9.70358 36.184 10.3019 36.3169C11.3252 36.5443 11.2483 36.2863 11.8288 35.3533C13.2043 33.1427 15.1336 31.9407 17.1065 30.4611",
    stroke: "#8BBA33",
    strokeWidth: 3.33739,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaabajo);
export default __webpack_public_path__ + "static/media/flechaabajo.b669d731778d6f5a9ec258211d0a1f81.svg";
export { ForwardRef as ReactComponent };